import React from 'react'
import Head from 'next/head'
import PolicyContent from '../components/PolicyContent'
import getConfig from 'next/config'

interface ContainerProps {
  termsandConditionsData: any
}

const Terms: React.FC<ContainerProps> = ({ termsandConditionsData }) => {
  const templateArr = JSON.parse(termsandConditionsData?.template)
  const headerTitle = templateArr.find(temp => temp.type === 'headertitle')
  return (
    <div id="main-content">
      <Head>
        <title>pOpshelf Terms and Conditions</title>
        <meta
          name="description"
          content="PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY AS THEY AFFECT YOUR LEGAL RIGHTS."
        />
      </Head>
      <div className="privacy-policy" id="privacypolicy">
        <div className="privacy-policy__hero-ribbon">
          <h1>{headerTitle.value}</h1>
        </div>
        <PolicyContent templateData={templateArr} />
      </div>
    </div>
  )
}

export const getServerSideProps = async ({ req }) => {
  const { publicRuntimeConfig } = getConfig()
  const res = await fetch(
    `${publicRuntimeConfig.APP_ENDPOINT}/api/user/${publicRuntimeConfig.ENV}/policypage?popkey=${publicRuntimeConfig.POP_KEY}&slug=terms-and-conditions`
  )
  const response = await res.json()
  return {
    props: {
      termsandConditionsData: response[0]
    }
  }
}

export default Terms
